// extracted by mini-css-extract-plugin
module.exports = {"settingsContainer":"CBSettings_settingsContainer__1_Gn9","label":"CBSettings_label__32Our","inset":"CBSettings_inset__1LzMg"};